import Vue from 'vue';
import Vuex from 'vuex';
import options from '../../resource/store/web/webOfficialSupport';
Vue.use(Vuex);

export default new Vuex.Store(options);
